<script>
  import { createEventDispatcher, getContext, setContext } from 'svelte'
  import { createSelector } from './../utils.js'
  import { cssPrefix } from '../helper-classes.js'

  export let opened = true
  export let narrow = false
  export let multiple = false

  const dispatch = createEventDispatcher()
  const selector = createSelector(multiple)
  const dropdown = getContext('currentDropdown')

  // sync with dropdown contex opened state
  if (dropdown) {
    dropdown.opened.set(opened)
    dropdown.opened.subscribe(state => {
      opened = state
    })
  }

  // sync back prop to dropdown conext
  $: if (dropdown) dropdown.opened.set(opened)

  const onSelect = index => dispatch('select', index)

  setContext('currentDropdownList', { selector, onSelect })

  const classes = [`${cssPrefix}dropdown`]

  if (narrow) classes.push('is-narrow')
</script>

{#if opened}
  <div class={classes.join(' ')}>
    <ul class={`${cssPrefix}dropdown-list`}>
      <slot />
    </ul>
  </div>
{/if}
